import { useState } from 'react';
import { styles } from '../styles';
import { api } from '../api';

export default function LoginScreen({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await api.post('/auth/login', { password });
      onSuccess();
    } catch (err) {
      setError('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ padding: 20, maxWidth: 300, margin: '100px auto' }}>
        <h1 style={{ textAlign: 'center', marginBottom: 30 }}>Budget Tracker</h1>
        
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ ...styles.input, width: '100%', marginBottom: 15 }}
        />
        
        {error && <p style={{ color: 'red', marginBottom: 15 }}>{error}</p>}
        
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{ ...styles.button, width: '100%' }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </div>
  );
}